<template>
  <div>
    {{conditionSets}}
    <div>
      <div>
        <div v-if="!dealLevel" class="row card oc-generic-card-body">
          <h6 class="oci-blue mb-3 ml-2">
            Groups
          </h6>

          <el-table
            v-loading="groupsTableLoading"
            element-loading-text="Loading..."
            size="mini"
            ref="groupsTable"
            border
            highlight-current-row
            :data="groups">
            <el-table-column
              width="180px"
              label="Group Name"
              prop="groupName">
            </el-table-column>
            <el-table-column
              label="Description"
              prop="description">
            </el-table-column>


            <el-table-column
              label=""
              align="center"
              width="65">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-view"
                  size="small"
                  @click="filterConditions(scope.row.groupName)">
                </el-button>
              </template>
            </el-table-column>


            <el-table-column
              v-if="!dealLevel"
              label=""
              align="center"
              @cell-click.stop="filterConditions"
              width="65">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit-outline"
                  size="small"
                  @click="editGroup(scope.row)">
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-if="!dealLevel"
              label=""
              align="center"
              width="65">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  size="small"
                  @click="removeConditionSet(scope.row)">
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pt-3">
            <el-pagination
              @current-change="groupsChangePage"
              layout="prev, pager, next"
              small
              :current-page="groupsPagination.currentPage"
              :pager-count="7"
              :page-size="groupsPagination.perPage"
              :total="groupsTotal">
            </el-pagination>
            <div>
              <p class="card-category">Showing {{groupsFrom + 1}} to {{groupsTo}} of {{groupsTotal}} entries</p>
            </div>
            <div>
              <p class="oci-blue">Display per page:
                <el-select
                  class=""
                  style="width: 100px"
                  v-model="groupsPagination.perPage"
                  size="mini"
                  @change="filterConditionsByGroup"
                  placeholder=" ">
                  <el-option
                    class="select-default"
                    v-for="item in groupsPagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </p>
            </div>
          </div>

          <modal :show.sync="modals.notice"
                 footerClasses="justify-content-center"
                 modalClasses="justify-content-center"
                 style="padding-top: 100px"
                 type="notice">
            <h5 slot="header" class="modal-title oci-white">Are you sure?</h5>
            <template>
              <div style="text-align: center">
                <h5>Are you sure?</h5>
              </div>
              <div class="row">
                <div class="col-md-4 offset-md-1 ">
                  <n-button type="success" @click.native="deleteConditionSet">Yes, delete</n-button>
                </div>
                <div class="col-md-4 offset-md-2">
                  <n-button type="danger" @click.native="modals.notice = false">No, cancel</n-button>
                </div>
              </div>
            </template>
          </modal>


          <el-button
            v-if="!creatingGroup && !dealLevel"
            type="primary"
            plain
            size="small"
            style="float: right; width: 100px; height: 30px"
            @click="createGroup">New Group
          </el-button>

          <el-button v-if="!creatingGroup && selectedGroup"
                     type="danger"
                     plain
                     class="mr-2"
                     style="float: right; width: 100px; height: 30px"
                     size="small"
                     @click="cancelGroupEdit">Clear
          </el-button>
        </div>
        <div v-if="creatingGroup" class="row card oc-generic-card-body mt-2">
          <h6 v-if="newConditionSet.conditionSetId" class="text-primary  mb-3 mt-3">Edit Group</h6>
          <h6 v-if="!newConditionSet.conditionSetId" class="text-primary  mb-3 mt-3">New Group</h6>
          <div class="row">
          <div  class="col-md-4">
            <div class="row">
              <div class="col-md-5"><label>Group Name</label></div>
              <div class="col-md-7">
                <input type="text"
                       class="form-control"
                       v-model="newConditionSet.groupName"
                       placeholder="Group Name">
              </div>
            </div>
          </div>
          <div v-if="creatingGroup" class="col-md-6">
            <div class="row">
              <div class="col-md-4"><label>Description</label></div>
              <div class="col-md-8">
                <input type="text"
                       class="form-control"
                       v-model="newConditionSet.description"
                       placeholder="Description">
              </div>
            </div>
          </div>
          <!-- <div class="col-md-2">
            <el-button v-if="creatingGroup && newConditionSet.groupName"
                       type="button"
                       class="btn-sm btn-success"
                       style="float: right; width: 100px; height: 30px"
                       size="small"
                       @click="saveConditionSet">Save
            </el-button>
            <el-button v-if="creatingGroup && !newConditionSet.groupName"
                       type="button"
                       style="float: right; width: 100px; height: 30px"
                       size="small"
                       disabled
                       @click="saveConditionSet">Save
            </el-button>

          </div> -->
          </div>
        </div>
        <div class="row card oc-generic-card-body">
          <div>

            <div class="row mb-3 mt-3">
              <div class="col-md-6">
                <h6 class="oci-blue">
                  Conditions
                  <span v-if="newConditionSet && newConditionSet.groupName">:&nbsp All<!--{{newConditionSet.groupName}}--></span>
                  <span v-if="newConditionSet && !newConditionSet.groupName && !selectedGroup">:&nbsp All</span>
                  <span v-if="selectedGroup">:&nbsp{{selectedGroup}}</span>
                </h6>
                <div v-if="newConditionSet && newConditionSet.groupName" style="font-size: 12px"><span style="color: red">**</span>Select or deselect a condition, then click save to add or remove from the <b>{{newConditionSet.groupName}}</b>
                  </div>
              </div>
              <div v-if="dealLevel" class="col-md-12" >
                <div class="row" style="float: right">
                  <label class="pt-1">Select Group</label>
                  <select
                    class="form-control"
                    style="width: 150px"
                    v-model="selectedGroup"
                    @change="filterConditions($event.target.value)">
                    <option
                      v-for="(a, index) in groups"
                      :value="a.groupName">
                      {{a.groupName}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <el-table
              v-loading="conditionsTableLoading"
              element-loading-text="Loading..."
              ref="conditionsTable"
              :data="conditionDetails"
              row-key="conditionId"
              @cell-click="onCellClick"
              size="mini"
              border
              @selection-change="handleSelectionChange">

              <el-table-column v-if="creatingGroup || dealLevel" type="selection" :reserve-selection="true" width="36">
              </el-table-column>

              <el-table-column prop="conditionName" label="Condition Name" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="groups" label="Groups" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="conditionDescription" label="Condition Description" show-overflow-tooltip>
              </el-table-column>

              <el-table-column v-if="dealLevel" prop="appliesTo" label="Applies To">
                <template slot-scope="scope">
                  <editable-column-dropdown
                    :is-editing="isEditing" :scope="scope" :editing="editing" property="appliesTo"
                    @blur-input="onCellBlur" @enter-input="onCellBlur" :options="appliesTo">
                  </editable-column-dropdown>
                </template>
              </el-table-column>

              <el-table-column v-if="!dealLevel" prop="appliesTo" label="Applies To">
              </el-table-column>


              <el-table-column
                v-if="!dealLevel"
                label=""
                class="mt-0 mb-0 pt-0 pb-0"
                align="center"
                width="65">

                <template slot-scope="scope" class="mt-0 mb-0 pt-0 pb-0">
                  <el-button
                    class="mt-0 mb-0 pt-0 pb-0"
                    type="text"
                    icon="el-icon-edit-outline"
                    size="small"
                    @click="editCondition(scope.row)">
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                v-if="!dealLevel"
                label=""
                class="mt-0 mb-0 pt-0 pb-0"
                align="center"
                width="65">
                <template slot-scope="scope" class="mt-0 mb-0 pt-0 pb-0">
                  <el-button
                    class="mt-0 mb-0 pt-0 pb-0"
                    type="text"
                    icon="el-icon-delete"
                    size="small"
                    @click="removeCondition(scope.row)">
                  </el-button>
                </template>
              </el-table-column>

            </el-table>

            <modal :show.sync="modals.classic"
                   footerClasses="justify-content-center"
                   modalClasses="justify-content-center"
                   style="padding-top: 100px"
                   type="notice">
              <h5 slot="header" class="modal-title oci-white">Are you sure?</h5>
              <template>
                <div style="text-align: center">
                  <h5>Are you sure?</h5>
                </div>
                <div class="row">
                  <div class="col-md-4 offset-md-1 ">
                    <n-button type="success" @click.native="deactivateCondition">Yes, delete</n-button>
                  </div>
                  <div class="col-md-4 offset-md-2">
                    <n-button type="danger" @click.native="modals.classic = false">No, cancel</n-button>
                  </div>
                </div>
              </template>
            </modal>

          </div>

          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap pt-3">
            <el-pagination
              @current-change="changePage"
              layout="prev, pager, next"
              small
              :current-page="pagination.currentPage"
              :pager-count="7"
              :page-size="pagination.perPage"
              :total="total">
            </el-pagination>
            <div>
              <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
            </div>
            <div>
              <p class="oci-blue">Display per page:
                <el-select
                  class=""
                  style="width: 100px"
                  v-model="pagination.perPage"
                  size="mini"
                  @change="filterConditionsByGroup"
                  placeholder=" ">
                  <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </p>
            </div>
          </div>

          <el-button v-if="creatingGroup && newConditionSet.groupName"
                     type="success"
                     plain
                     style="float: right; width: 100px; height: 30px"
                     size="small"
                     @click="saveConditionSet">Save
          </el-button>
          <el-button v-if="creatingGroup && !newConditionSet.groupName"
                     type="info"
                     plain
                     style="float: right; width: 100px; height: 30px"
                     size="small"
                     disabled
                     @click="saveConditionSet">Save
          </el-button>

          <el-button v-if="creatingGroup"
                     type="danger"
                     plain
                     class="mr-2"
                     style="float: right; width: 100px; height: 30px"
                     size="small"
                     @click="cancelGroupEdit">Cancel
          </el-button>
          <el-button v-if="!dealLevel && !creatingGroup"
                     type="primary"
                     style="float: right"
                     size="small"
                     @click="newCondition">New Condition
          </el-button>
          <el-button v-if="dealLevel && multipleSelection && multipleSelection.length > 0"
                     type="primary"
                     style="float: right"
                     size="small"
                     plain
                     @click="addToDeal">Add to Deal
          </el-button>

        </div>

        <div v-if="addNewCondition" class="row card oc-generic-card-body pt-3">
          <h6 v-if="!condition.conditionId" class="text-primary mb-1 mt-2 pb-3">New Condition</h6>
          <h6 v-if="condition.conditionId" class="text-primary mb-1 mt-2 pb-3">Edit Condition</h6>


          <div v-if="addNewCondition">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-4"><label>Condition</label></div>
                  <div class="col-md-8">
                    <input type="text"
                           id="addConditionName"
                           class="form-control"
                           placeholder="condition name"
                           v-model="condition.conditionName">
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-4"><label>Condition Description</label></div>
                  <div class="col-md-8">
                    <input type="text"
                           id="addConditionDescription"
                           class="form-control"
                           placeholder="description"
                           v-model="condition.conditionDescription">
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-4"><label>Applies To</label></div>
                  <div class="col-md-8">
                    <select
                      id="campaign"
                      v-model="condition.appliesTo"
                      class="form-control"
                    >
                      <option value=""></option>
                      <option
                        v-for="(level, index) in ['Application', 'Applicants']"
                        v-bind:key="index"
                        :value="level">
                        {{level}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-md-4" v-if="!condition.conditionId">
                <div class="row">
                  <div class="col-md-4"><label>Add To Existing Group</label></div>
                  <div class="col-md-8">
                    <select
                      id="existingGroup"
                      v-model="existingConditionSet"
                      class="form-control">
                      <option value=""></option>
                      <option
                        v-for="(grp, index) in groups"
                        v-bind:key="index"
                        :value="grp">
                        {{grp.groupName}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="addNewCondition">

            <el-button v-if="(!condition.conditionName)"
                       disabled
                       type="info"
                       plain
                       style="float: right; width: 100px; height: 30px"
                       size="small">Save
            </el-button>

            <el-button v-if="condition.conditionName"
                       type="success"
                       plain
                       style="float: right; width: 100px; height: 30px"
                       v-on:click="saveNewCondition">Save
            </el-button>

            <el-button type="danger"
                       plain
                       class="mr-2"
                       style="float: right; width: 100px; height: 30px"
                       size="small"
                       v-on:click="cancelSave">Cancel
            </el-button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @author Ankita
 * @author Marinus
 * This is the Conditions Template page (child component) for Admins or Brokers to be able to create default or Generic Condition Groups and conditions based on en-numerable demands that can take place
 */
  import {
    Table,
    TableColumn,
    Select,
    Option,
    Button,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Pagination
  } from 'element-ui'
  import {Modal} from '@/common/components/index';
  import {Pagination as NPagination} from '@/common/components/index';
  import ApplicationConditions from "@/broker/components/conditionsComponents/ApplicationConditions.vue";
  import ConditionsMultiSelectDropDown
    from "@/broker/components/conditionsComponents/ConditionsMultiSelectDropDown.vue";
  import EditableColumnTypeText from '@/common/components/EditableColumnTypeText';
  import EditableColumnTypeDropdown from '@/common/components/EditableColumnTypeDropdown'


  export default {
    components: {
      ApplicationConditions,
      NPagination,
      [Pagination.name]: Pagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      Modal,
      'editable-column-text': EditableColumnTypeText,
      'conditions-multiselect-dropdown': ConditionsMultiSelectDropDown,
      'editable-column-dropdown': EditableColumnTypeDropdown,
    },
    name: "ConditionSetTable",
    data() {
      return {
        groups: [],
        groupsTableLoading: true,
        conditionsTableLoading : true,
        selectedConditions: null,
        conditionSetToBeRemoved: null,
        conditionToBeRemoved: null,
        newConditionSet: {
          groupName: null,
          description: null,
          conditionSetId: null,
          createdBy: null
        },
        existingConditionSet: {
          groupName: null,
          description: null,
          conditionSetId: null,
          createdBy: null
        },
        selectedGroup: null,
        groupSelected: null,
        conditionDetails: [],
        loanAppId: null,
        editing: null,
        checked: true,
        addCondition: false,
        addNewCondition: false,
        swalTitle: "",
        swalType: "",
        // defaultOption:'All,
        groupsPagination: {
          perPage: 10,
          defaultActive: 'All',
          currentPage: 1,
          perPageOptions: [10, 20, 40, 80],
          filterOptions: ['All', 'Yes', 'No'],
          total: 0
        },
        pagination: {
          perPage: 10,
          defaultActive: 'All',
          currentPage: 1,
          perPageOptions: [10, 20, 40, 80],
          filterOptions: ['All', 'Yes', 'No'],
          total: 0
        },
        modals: {
          notice: false,
          classic: false,
        },
        searchQuery: null,
        multipleSelection: [],
        searchedData: [],
        currentRow: null,

        creatingGroup: false,
        condition: {
          conditionDescription: null,
          conditionName: null,
          fulfilledBy: null,
          appliesTo: null
        },
      };
    },
    props: {
      dealLevel: false
    },
    watch: {
      conditions: {
        immediate: false,
        handler() {
          this.filterConditionsByGroup();
        }
      },
      conditionSets: {
        immediate: false,
        handler() {
          this.filterConditionsByGroup();
        }
      }
    },
    computed: {
      conditions: {
        get() {
          return this.$store.getters.conditions;
        }
      },
      appliesTo: {
        get() {
          let appliesTo = [{
            type:'Application',
            id: 'Application',
            name: 'Application'
          }, {
            type:'Applicants',
            id: 'Applicants',
            name: 'Applicants'
          }];
          return appliesTo;
        }
      },
      conditionsLoading: {
        get() {
          return this.$store.getters.conditionsLoading;
        }
      },
      conditionSets: {
        get() {
          let val = JSON.parse(JSON.stringify(this.$store.getters.conditionSets));
          if (val) {
            this.groups = val;
            if(this.dealLevel){
              this.groups.unshift({
                groupName: 'All'
              });
            }
          }
        }
      },
      isEditing: {
        get() {
          return this.editing !== null
        }
      },
      groupsTo() {
        let highBound = this.groupsFrom + this.groupsPagination.perPage;
        if (this.groupsTotal < highBound) {
          highBound = this.groupsTotal;
        }
        return highBound
      },
      groupsFrom() {
        return this.groupsPagination.perPage * (this.groupsPagination.currentPage - 1)
      },
      groupsTotal() {
        if(this.$store.getters.conditionSets){
          return this.$store.getters.conditionSets.length;
        }
        return 0;
      },

      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        return this.pagination.total;
      }
    },
    methods: {
      groupsChangePage(page) {
        this.groupsPagination.currentPage = page;
        this.filterConditionsByGroup();
      },
      changePage(page) {
        this.pagination.currentPage = page;
        this.filterConditionsByGroup();
      },
      cancelGroupEdit() {
        this.groupsPagination.currentPage = 1;
        this.pagination.currentPage = 1;
        this.selectedConditions = null;
        this.newConditionSet = {};
        this.creatingGroup = false;
        this.selectedGroup = null;
        this.filterConditionsByGroup();
        this.$refs.conditionsTable.clearSelection();
      },
      createGroup() {
        this.addNewCondition = false;
        this.selectedGroup = null;
        this.creatingGroup = !this.creatingGroup;
        this.filterConditionsByGroup();
      },
       filterConditionsByGroup() {
        this.groupsTableLoading = true;
         this.conditionsTableLoading = true;
        this.conditionDetails = [];
        let conditions = JSON.parse(JSON.stringify(this.$store.getters.conditions));
        let selectedRows = [];
        for (let i = 0; i < conditions.length; i++) {
          if (conditions[i].conditionSets.length < 1 && !this.selectedGroup || this.selectedGroup === 'All') {
            this.conditionDetails.push(conditions[i]);
          } else {
            let conditionAdded = false;
            for (let j = 0; j < conditions[i].conditionSets.length; j++) {
              if (conditions[i].conditionSets[j].groupName === this.selectedConditions || !this.selectedGroup || conditions[i].conditionSets[j].groupName === this.selectedGroup || this.selectedGroup === 'All') {
                if (conditions[i].conditionSets[j].groupName === this.selectedConditions) {
                  selectedRows.push(conditions[i]);
                }
                if (!conditionAdded) {
                  this.conditionDetails.push(conditions[i]);
                  conditionAdded = true;
                }
              }
            }
          }
        }

        //Pagination for Groups
         if(this.$store.getters.conditionSets){
           this.groups = JSON.parse(JSON.stringify(this.$store.getters.conditionSets));
           this.groupsPagination.total = this.$store.getters.conditionSets.length;

           if (!this.dealLevel && this.groups.length > this.groupsPagination.perPage) {
             if (this.groupsPagination.currentPage > 1) {
               this.groups.splice(0, (this.groupsPagination.perPage * (this.groupsPagination.currentPage - 1)));
             }
             let leftOver = this.groupsPagination.total - this.groupsPagination.perPage * this.groupsPagination.currentPage;
             if (leftOver < 0) {
               leftOver = 0;
             }
             this.groups.splice(this.groupsPagination.perPage * (this.groupsPagination.currentPage), leftOver);
           }
         }


        //Pagination for Conditions
        this.pagination.total = this.conditionDetails.length;
        if (this.conditionDetails.length > this.pagination.perPage) {
          let leftOver = this.pagination.total - this.pagination.perPage * this.pagination.currentPage;
          if (leftOver < 0) {
            leftOver = 0;
          }
          if (this.pagination.currentPage > 1) {
            this.conditionDetails.splice(0, (this.pagination.perPage * (this.pagination.currentPage - 1)));
          }else{
            this.conditionDetails.splice(this.pagination.perPage * (this.pagination.currentPage), leftOver);
          }
        }
        if (!this.selectedGroup) {
           this.changeSelection(selectedRows);
        }
         this.conditionsTableLoading = false;
        this.groupsTableLoading = false;
         this.findGroups()
      },
      findGroups(){
        for(let condition of this.conditionDetails){
          let groups = "";
          for(let group of condition.conditionSets){
            if (groups.length === 0) {
              groups = group.groupName;
            } else {
              groups += ', ' + group.groupName;
            }
          }
          condition.groups = groups;
        }
      },
      async editGroup(group) {
        this.addNewCondition = false;
        this.pagination.currentPage = 1;
        this.selectedGroup = null;
        this.creatingGroup = true;
        this.newConditionSet = JSON.parse(JSON.stringify(group));
        if (typeof (group) === 'object') {
          this.selectedConditions = group.groupName;
          await this.filterConditionsByGroup()
        } else {
          this.selectedConditions = group;
          await this.filterConditionsByGroup()
        }
      },
      async changeSelection(rows) {
        this.$refs.conditionsTable.clearSelection();
        if (rows && rows.length > 0) {
          rows.forEach(row => {
            this.$refs.conditionsTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.conditionsTable.clearSelection();
        }
      },
      async saveNewCondition() {
        this.conditionsTableLoading = true;
        if(this.existingConditionSet.conditionSetId==null){
          await this.$store.dispatch('saveCondition', this.condition);
        }else{
          let obj = {
            conditionSet: this.existingConditionSet,
            conditions: this.condition
          };
          await this.$store.dispatch('saveConditionWithConditionSet', obj);
          obj = {};
          this.addNewCondition = false;
        }
        this.filterConditionsByGroup();
        this.condition = {};
        this.addNewCondition = false;
        this.existingConditionSet = {};
      },
      editCondition(condition) {
        this.$refs.conditionsTable.clearSelection();
        this.creatingGroup = false;
        this.addNewCondition = true;
        this.condition = JSON.parse(JSON.stringify(condition));
        this.existingConditionSet = this.condition.conditionSets[0];
      },
      filterConditions(group) {
        this.$refs.conditionsTable.clearSelection();
        this.pagination.currentPage = 1;
        this.creatingGroup = false;
        this.newConditionSet = {};
        if (typeof (group) === 'object') {
          this.selectedGroup = group.groupName;
          this.filterConditionsByGroup();
        } else {
          this.selectedGroup = group;
          this.filterConditionsByGroup();
        }
      },
      onCellBlur(object) {
        this.editing = null;
      },
      onCellClick(row, column, cell, event) {
        this.editing = {
          row,
          column,
          cell
        }
      },
      async saveConditionSet() {
        let obj = {
          conditionSet: this.newConditionSet,
          conditions: this.multipleSelection
        };
        this.groupsTableLoading = true;
        await this.$store.dispatch('saveConditionSet', obj);
        this.creatingGroup = false;
        this.selectedConditions = null;
        this.filterConditions(this.newConditionSet.groupName);
        this.newConditionSet = {};
      },
      addToDeal() {
        this.$emit('conditionsTemplate', this.multipleSelection);

      },
      newCondition() {

        this.addNewCondition = true;
        this.condition = {
          conditionName: null,
          conditionDescription: null,
          active: true
        };
        this.selectedGroup=null;
        this.filterConditionsByGroup();
      },

      handleCurrentChange(val) {
        this.currentRow = val;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      cancelSave() {
        this.groupSelected = null;
        this.addNewCondition = false;
        this.addCondition = false;
        this.condition = {};
      },
      removeCondition(condition) {
        this.modals.classic = true;
        this.conditionToBeRemoved = condition;
      },
      removeConditionSet(conditionSet) {
        this.modals.notice = true;
        this.conditionSetToBeRemoved = conditionSet;
      },
      deleteConditionSet() {
        this.modals.notice = false;
        if (this.conditionSetToBeRemoved.conditionSetId != null) {
          this.$store.dispatch('deactivateConditionSet', this.conditionSetToBeRemoved).then(() => {
          })
        }
      },
      deactivateCondition() {
        this.modals.classic = false;
        if (this.conditionToBeRemoved.conditionId != null) {
          this.$store.dispatch('deactivateCondition', this.conditionToBeRemoved).then(() => {
          })
        }
      }
    },
    mounted() {
      this.$store.dispatch('getConditionSets');
      let object = {
        groupName: '0',
        dealLevel: false
      };
      this.$store.dispatch('loadConditions', object);
      if(this.dealLevel){
        this.loanAppId = this.$crypto.decodeIdParam(this.$route.query.loanApp);
        this.$store.dispatch('getAllAppApplicantsByLoanAppId', this.loanAppId);
      }
    },
  }
</script>

<style scoped>
  tr:hover {
    background-color: #ffa;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: black !important;
  }

</style>
